function setMatrixElement(matrixData, columns, row, column, value) {
    matrixData[column + row * columns] = value;
}
export default setMatrixElement;
//# sourceMappingURL=set-matrix-element.js.map